import { Base } from '@gate31/core/src/libs/BaseComponent';
import { ReviewsForm } from '@gate31/feature/ReviewsForm/ReviewsForm';

export class ReviewsFormDesk extends ReviewsForm {
    static cn = new Base.BuildCn('ReviewsFormDesk');
}
